import React, { FC, useCallback } from 'react';
import { CustomLayout } from 'layout/custom/custom';
import { Header } from 'common/layout';
import { IoMdMore } from 'react-icons/io';
import { Dropdown } from 'common/dropdown';
import { useVehicularDocuments } from 'pages/vehicle-documents/use-vehicular-documents';
import { Loading } from 'common/loading';
import { useModal } from 'state/modal';
import { ConfirmMessageContent } from 'common/modals/confirm-message';
import { PdfElement } from 'common/pdf-viewer/pdf-viewer.types';
import { VehicleDocumentsBody, ErrorMessage } from './components';

import styles from './vehicle-document.module.scss';

export const VehicleDocumentsPage: FC<{ isVehicularCheckPoint?: boolean }> = ({ isVehicularCheckPoint = false }) => {
  const { data, errorMessage, isError, isLoading, onAttachDocuments, onDelete, onDownloadDocuments, onNavigate } =
    useVehicularDocuments(isVehicularCheckPoint);

  const { showModal: openConfirmDeleteModal } = useModal({
    template: <ConfirmMessageContent message="¿Está seguro que desea eliminar este archivo de forma permanente?" />,
    title: 'Eliminar documento',
  });

  const actions = React.useMemo(
    () => [
      {
        id: isVehicularCheckPoint ? 'doc-vehicle' : 'vehicular-check-point',
        label: isVehicularCheckPoint ? 'Documentos del Vehículo' : 'Control Vehicular',
      },
      {
        id: 'attach',
        label: 'Adjuntar documentos',
      },
      { id: 'download', label: 'Descargar' },
    ],
    [isVehicularCheckPoint],
  );

  const onSelectItem = useCallback(
    item => {
      if (item.id === 'attach') {
        return onAttachDocuments();
      }

      if (item.id !== 'download') {
        return onNavigate();
      }
      onDownloadDocuments();
    },
    [data],
  );

  const onConfirmDelete = useCallback((doc: PdfElement) => {
    openConfirmDeleteModal({ onConfirm: () => onDelete(doc) });
  }, []);

  const props = {
    data,
    isVehicularCheckPoint,
    onAttachDocuments,
    onDelete: onConfirmDelete,
    onDownloadDocuments,
    onNavigate,
  };

  if (isError || errorMessage) {
    return <ErrorMessage message={errorMessage} />;
  }

  if (isLoading) {
    return <Loading />;
  }

  if (!data) {
    return <div />;
  }

  return (
    <CustomLayout
      body={<VehicleDocumentsBody {...props} />}
      header={
        <Header title={!isVehicularCheckPoint ? 'Documentos del vehículo' : 'Control vehicular'}>
          <Dropdown className={styles.mobileHeaderActions} items={actions} onSelectItem={onSelectItem}>
            <IoMdMore size={18} />
          </Dropdown>
        </Header>
      }
    />
  );
};
